import React from 'react';
import { Grid } from '../../../../../components/Grid/Grid';
import { Event } from '../../../../../model/event';
import { GeneralInfo } from './GeneralInfo';
import { Owner } from './Owner';
import { Venue } from './Venue';
import { DelayedOnlineTickets } from './delayed_online_tickets';

export function Details({ event }: { event: Event }): JSX.Element {
  return (
    <Grid>
      <GeneralInfo event={event} />
      <Venue event={event} />
      <Owner event={event} />
      <DelayedOnlineTickets event={event} />
    </Grid>
  );
}
